import { IAppointmentsReport } from '../../../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from '../../interface/IAPIAppointmentsReport'

import { createGroupData } from './createGroupData'

export const formatForYear = (
    apiData: IAPIAppointmentsReport[]
): IAppointmentsReport[] => {
    const yearStart: number = 0

    const monthsOfYearArray = Array.from(
        { length: 12 },
        (v, i) => yearStart + i
    )

    return monthsOfYearArray.map(
        (monthNumber): IAppointmentsReport =>
            createGroupData(apiData, monthNumber, 'month' )
    )
}
